import React, { useEffect, useState } from 'react'
import Stars from './Stars'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { Row, Col, Button } from 'reactstrap'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import { closeModal } from '../../GlobalModal/redux/GlobalModalActions'
import { clearErrorOnHandleChange } from '../../../actions/errorsActions'

import { notificationDanger, notificationSuccess } from '../../../utils/customToastify'

import { EFFORT_LEVEL, PROSPECT_GRADE, PROSPECT_SOURCE } from '../../../constants/supportTypes'

const ConvertUnassignedProspect = ({ callbackAfterSubmit, contactId, contact }) => {
  const dispatch = useDispatch()
  const [data, setData] = useState({})

  const [submitting, setSubmitting] = useState(false)

  const [options, setOptions] = useState({
    ProspectGrade: [],
    ProspectSource: [],
    EffortLevel: [],
  })

  useEffect(() => {
    loadTypes()
  }, [])

  const loadTypes = async () => {
    const response = await axios.get(
      `/support-types/supportTypesForSelects/?types=${PROSPECT_SOURCE}&types=${PROSPECT_GRADE}`
    )
    let options = {}
    response.data.map((i) => {
      return (options[i.name.replace(/\s/g, '')] = i.data)
    })
    setOptions(options)
  }

  const convertContact = async () => {
    setSubmitting(true)

    if (!data.prospectSource || !data.grade) {
      notificationDanger('Please enter all data!')
      setSubmitting(false)
      return
    }

    const resp = await axios.post('/contacts/convert-un-prospect', {
      contactId,
      creationDate: new Date(),
      prospectSource: data.prospectSource,
      grade: data.grade,
    })

    if (resp.status === 200) {
      dispatch(closeModal('convert_unassigned_prospect'))
      notificationSuccess('⭐ Conversion successful ⭐')
      await callbackAfterSubmit()
    }
  }

  const handleChange = (e, name) => {
    setData({ ...data, [name]: e.id })
  }

  return (
    <>
      <div className='contact_convert'>
        <div style={{ marginLeft: '4%' }}>
          Are you sure you wish to <span className='font-weight-bold'>{`claim & convert`}</span> this Unassigned
          Prospect to an <span className='font-weight-bold'>Prospect</span>
        </div>
        <p
          style={{
            color: '#D9534F',
            fontWeight: '600px',
            marginTop: '9px',
            marginLeft: '4%',
          }}
        >
          <i className='fa fa-hand-o-right' /> Select the Effort Level &amp; Grade to proceed:
        </p>
        <Row>
          <Col className='effort_level_box' xs={12} md={6} lg={6}>
            <div className='font-weight-bold effort_level_box-title'>Effort Level</div>
            <div className='effort_level_box-stars'>
              <Stars effortLevelIds={options.EffortLevel} handleChange={handleChange} contact={contact} />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} className='customBoxSmaller'>
            <CustomSelect
              isMulti={false}
              label='Grade'
              placeholder='Grade'
              onChange={(e) => handleChange(e, 'grade')}
              defaultValue={data.grade || 0}
              options={[{ name: 'Please Select' }, ...options.ProspectGrade]}
            />
          </Col>
          <Col xs={12} md={6} lg={6} />
          <Col xs={12} md={6} lg={6} className='mt-3 customBoxSmaller'>
            <CustomSelect
              isMulti={false}
              label={'Prospect Source'}
              placeholder={'Prospect Source'}
              onChange={(e) => handleChange(e, 'prospectSource')}
              defaultValue={data.prospectSource || 0}
              options={[{ name: 'Please Select' }, ...options.ProspectSource]}
            />
          </Col>
        </Row>
        <Row className='justify-self-bottom text-right convertBox'>
          <Col className=''>
            <Button className={'btn btn-gold'} onClick={() => convertContact()} disabled={submitting}>
              Ok
            </Button>
            <Button className={'btn btn-gold ml-3'} onClick={() => closeModal('converting_contacts')}>
              Cancel
            </Button>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default ConvertUnassignedProspect
